<template>
    <div>

      <div class="btn-group d-flex justify-content-center  " role="group" aria-label="Basic mixed styles example">
        <button type="button" class="btn btn-sm btn-primary" data-bs-toggle="modal" data-bs-target="#dadosTecnicos">
          <i class="fas fa-info-circle"></i> Dados tecnicos</button>
      </div>

        <div class="modal fade mt-4" id="dadosTecnicos" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false"  aria-labelledby="dadosTecnicos" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title p-3" id="exampleModalLabel">Dados tecnicos</h5>
                <button type="button" class="btn-close btn-black" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body p-3">
                <table class="table">
                    <thead>
                        <tr>
                        <th scope="col">Informações</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                        <td>Óleo recomendado</td>
                        <td>15w40</td>
                        </tr>

                        <tr>
                        <td>Litros de óleo</td>
                        <td>3 litros</td>
                        </tr>

                        <tr>
                        <td>Litros de água</td>
                        <td>5 litros</td>
                        </tr>
  

                        <tr>
                        <td>Tanque de combustivel</td>
                        <td> 60 litros</td>
                        </tr>

                        <tr>
                        <td>Peso</td>
                        <td> 1170kg</td>
                        </tr>

                        <tr>
                        <td>Porta Mala</td>
                        <td> 370 litros</td>
                        </tr>

                        <tr>
                        <td>IPVA</td>
                        <td>R$ 514,00</td>
                        </tr>
  

                        <tr>
                        <td>Preço FIPE</td>
                        <td>R$ 12.000</td>
                        </tr>
  

                        <tr>
                        <td>Litros de água</td>
                        <td>5 litros</td>
                        </tr>
  
                    </tbody>
                </table>
              </div>
              <div class="modal-footer p-3">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fechar</button>
              </div>
            </div>
          </div>
        </div>

     
    </div>
</template>

<script>

    export default {
       components: {
          
       }, 
    }
</script>

<style lang="css" scoped>

.btn-primary {
    color: var(--main-red-black);
    background-color: var(--main-white);
    border-color: var(--main-red-black);
}

.btn-outline-primary {
    color: var(--main-red-black);
    border-color: var(--main-red-black);
}

.title-list{
    font-size: 1rem;
  font-weight:900;
  padding-top:1%;
  font-family: 'Roboto',sans-serif;
  color:var(--main-red-black);
  text-transform:uppercase;
}

.btn-primary:focus,.btn-primary:active {
   outline: none !important;
   box-shadow: none;
}


.btn-primary:hover, .btn-primary:focus, .btn-primary:active, .btn-primary.active, .open>.dropdown-toggle.btn-primary {
    color: #fff;
    background-color: var(--main-red-black);
    /*set the color you want here*/
}

.btn-primary:not(:disabled):not(.disabled):active, .btn-primary:not(:disabled):not(.disabled).active, .show > .btn-primary.dropdown-toggle {
    color: #fff;
    background-color: var(--main-red-black);
    border-color: var(--main-red-black);
}

.list-group-item-warning {
    color: var(--main-red-black);
    background-color: var(--main-white);
    border: 0.019rem solid var(--main-red-light);
}
.list-group-item.active {
    z-index: 2;
    color: var(--main-white);
    background-color: var(--main-red-black);
    border-color: var(--main-red-black);
    border-style: solid;
}

</style>